import { trackClientEvent } from '../../../../../trackClientEvent';
export const eventKey = 'product_info-product_details_customize_item_toggle-click';
/**
 * Tracks retailer clicks for the product customization toggle, under Product Details Page
 */
export function trackProductInfoProductDetailsCustomizeItemToggleClick() {
    return trackClientEvent({
        eventKey,
        realTimeTracking: false,
    });
}
